import { render, staticRenderFns } from "./ReservedSlotsList.vue?vue&type=template&id=2c95eecb"
import script from "./ReservedSlotsList.vue?vue&type=script&lang=ts"
export * from "./ReservedSlotsList.vue?vue&type=script&lang=ts"
import style0 from "./ReservedSlotsList.vue?vue&type=style&index=0&id=2c95eecb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports